import React, { memo } from "react";
import { areEqual } from "react-window";
import { stopPropagationHandler } from "../../utils";
import { LoadingOption } from "./LoadingOption";
export const VirtualizedOption = /*#__PURE__*/memo(_ref => {
  let {
    data,
    index,
    style
  } = _ref;
  const {
    getItemProps,
    getRenderedOption,
    highlightedIndex,
    options,
    getOptionKey,
    isOptionSelected,
    metadata
  } = data;
  const isLastRow = index === options.length;
  if (isLastRow) {
    return /*#__PURE__*/React.createElement("div", {
      style: style
    }, /*#__PURE__*/React.createElement(LoadingOption, null));
  }
  const option = options[index];
  const key = getOptionKey(option);
  return getRenderedOption(option, index, highlightedIndex, getItemProps({
    item: option,
    index,
    style: {
      ...style,
      width: "calc(100% - 16px)"
    },
    onClick: stopPropagationHandler,
    key
  }), isOptionSelected, metadata);
}, areEqual);
VirtualizedOption.displayName = "VirtualizedOption";
//# sourceMappingURL=VirtualizedOption.js.map